import { useSelector } from "react-redux";

const useClient = (clientId) => {
  return useSelector(({ hubly }) => {
    return {
      ...(hubly.data.hub.clients.activeClients[clientId] ?? {}),
    };
  });
};

export default useClient;
